import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ChannelUser } from 'src/app/Models/channel-user';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChanUserService {

  apiUrl: string;

  constructor(
    private httpclient: HttpClient
  ) {
      this.apiUrl = environment.apiUrl;
  }

  getChannelUsers(page: number, size: number, chanid: string, phone: string): Observable<any> {
    const url = this.apiUrl + '/api/channeluser/' + page + '/' + size + '/' + chanid
     + '/';
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  postChannelUser(user: ChannelUser): Observable<any> {
    return this.httpclient.post(this.apiUrl + '/api/channeluser', user)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  deleteChannelUser(user: ChannelUser): Observable<any> {
    return this.httpclient.put(this.apiUrl + '/api/channeluser/delete/id', user)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  private handleError(error: any): any {
    throw error;
    return error;
  }

}
